module.exports = __webpack_public_path__ + "static/media/heydoor_white.5e7b3c7d.png";